export default __webpack_public_path__ + "img/a5c194e64d75b3ef91e4631851a5c4d1.png";